// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__QX5v9","spin":"styles_spin__SCgK6"};